import { render, staticRenderFns } from "./OrderStaffCard.vue?vue&type=template&id=1b54ce96&"
import script from "./OrderStaffCard.vue?vue&type=script&lang=js&"
export * from "./OrderStaffCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports